<template>
  <footer>
      <div class="footer-box">
        <div class="footer-container clearfix">
          <dl class="footer-article-item0">
            <img src="../../assets/image/footLogo.png" alt />
          </dl>
          <dl class="footer-article-item1">
            <div class="footer-address">
              <dd>
                公司地址:
                <span>深圳市南山区留仙大道创智云城A2栋17至18层</span>
              </dd>
              <dd>
                工厂地址:
                <span>深圳市宝安区石岩街道塘头第三工业区12栋2楼</span>
              </dd>
            </div>
          </dl>
          <dl class="footer-article-item2">
            <div class="footer-address">
              <dd>
                联系电话：
                <span>0755-23614784</span>
              </dd>
              <dd>
                商务合作：
                <a target="_blank" href="http://BD@xtooltech.com">BD@xtooltech.com</a>
              </dd>
              <dd>
                媒体合作：
                <a target="_blank" href="http://PR@xtooltech.com">PR@xtooltech.com</a>
              </dd>
            </div>
          </dl>
          <dl class="footer-article-item3">
            <div class="footer-address">
              <dd>友情链接：</dd>
              <dd>
                <a
                  class="footer-link"
                  href="http://www.xtooltech.com/CN/Index.html"
                  target="_blank"
                >深圳市朗仁科技有限公司</a>
              </dd>
            </div>
          </dl>
        </div>
        <div class="footer-copyright">
          <p>
            深圳市云伽智能技术有限公司版权所有
            <a href="http://www.beian.miit.gov.cn/" target="_blank" rel="nofollow">©粤ICP备2023027284号-3</a>
          </p>
        </div>
      </div>
  	<div class="mobile-footer">
        <div class="mobile-foot">
          <p>深圳市云伽智能技术有限公司版权所有 <a href="http://www.beian.miit.gov.cn/" rel="nofollow" target="_blank">©粤ICP备2023027284号-3</a></p>
        </div>
      </div>
    </footer>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
  .clearfix::after {
      clear: both;
      content: ".";
      display: block;
      height: 0;
      visibility: hidden;
  }
  a {
      color: rgba(255, 255, 255, 1);
      text-decoration: none;
  }
  .footer-box{
      background: #0982D6;
      overflow: hidden;
      width: 100%;
      height: 4.64rem;
      color: rgba(255, 255, 255, 1);
      .footer-container {
          width: 100%;
          padding: 0 1rem;
          margin: 0 auto;
          box-sizing: border-box;
          [class^=footer-article-item]{
              height: 4rem;
              float: left;
              font-size: 0.16rem;
              position: relative;
              margin-right: .1rem;
              white-space: nowrap;
              .footer-address{
                  position: absolute;
                  top: 45%;
                  right: 0;
                  margin-top: -.5rem;
                  dd{
                      margin-bottom: .1rem;
                      line-height: 2;
                      font-weight: 300;
                      span,a{
                          margin-left: .1rem;
                      }
                      .footer-link{
                          margin: 0;
                      }
                  }
              }
          }
      }
      .footer-article-item0{
          background: url('../../assets/image/footimage.png') no-repeat;
          background-size: 100%;
          width: 3.9rem;
          img{
              display: block;
              width: 2.45rem;
              height: 0.8rem;
              position: absolute;
              left: -.2rem;
              right: 0;
              top: 0;
              bottom: 0;
              margin: auto;
          }
      }
      .footer-article-item1{
          width: 5rem;
      }
      .footer-article-item2,.footer-article-item3{
          width:3rem;
          float: right;
      }
      .footer-copyright{
          font-size: .14rem;
          text-align: center;
      }
  }
  @media screen and (max-width: 767px) {
      .footer-box {
        display: none;
      }
  }

  .mobile-footer {
      display: none;
      .mobile-foot {
          width: 100%;
          height: 64px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          color: rgba(255, 255, 255, 1);
          font-size: 12px;
          background: #0982D6;
          position: relative;
          p{
            white-space:normal;
          }
        }
  }

  @media screen and (max-width: 767px) {
      .mobile-footer {
        display: block;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/commons/footers.vue